import {
	request
} from './request'

// 头部导航
export const getNav = (data) => {
    return request({
        url: "/Api/Index/get_nav",
		method:'GET',
		params:data
    });
};

//语言列表
export const getLang = (data) => {
    return request({
        url: "/Api/Index/get_lang",
		method:'GET',
		params:data
    });
};

//公司介绍-体系认证
export const getCert = (data) => {
    return request({
        url: "/Api/Index/sys_cert",
		method:'GET',
		params:data
    });
};

//公司介绍-发展历程
export const getGrow = (data) => {
    return request({
        url: "/Api/Index/sys_grow",
		method:'GET',
		params:data
    });
};

//公司介绍-客户奖励
export const getReward = (data) => {
    return request({
        url: "/Api/Index/sys_reward",
		method:'GET',
		params:data
    });
};
//公司介绍-客户评价
export const getEvaluate = (data) => {
    return request({
        url: "/Api/Index/sys_evaluate",
		method:'GET',
		params:data
    });
};
//新闻中心
export const getNewsIndex = (data) => {
    return request({
        url: "/Api/News/index",
		method:'GET',
		params:data
    });
};
//新闻详情
export const getNewsDetail = (data) => {
    return request({
        url: "/Api/News/detail",
		method:'GET',
		params:data
    });
};
//新闻列表根据分类获取
export const getNewsList = (data) => {
    return request({
        url: "/Api/News/new_list",
		method:'GET',
		params:data
    });
};
//职业规划
export const getRecruit = (data) => {
    return request({
        url: "/Api/Recruit/index",
		method:'GET',
		params:data
    });
};
//联系我们
export const contactUs = (data) => {
    return request({
        url: "/Api/ContactUs/index",
		method:'GET',
		params:data
    });
};
//投资者关系
export const getRelation = (data) => {
    return request({
        url: "/Api/ContactUs/relation",
		method:'GET',
		params:data
    });
};
// 核心竞争力（列表）
export const getCompete = (data) => {
    return request({
        url: "/Api/Rdcenter/compete",
		method:'GET',
		params:data
    });
};
// 核心竞争力（分类文章）
export const getClassCon = (data) => {
    return request({
        url: "/Api/Rdcenter/index",
		method:'GET',
		params:data
    });
};
// 解决方案
export const getProductInfo = (data) => {
    return request({
        url: "/Api/Product/index",
		method:'GET',
		params:data
    });
};

// 合作企业
export const getPartnerList = (data) => {
    return request({
        url: "/Api/Product/partnership_list",
		method:'GET',
		params:data
    });
};
// 首页数据
export const getIndexInfo = (data) => {
    return request({
        url: "/Api/Index/index",
		method:'GET',
		params:data
    });
};
//语言包获取

export const getLangLable = (data) => {
    return request({
        url: "/Api/Index/get_lang_lable",
		method:'GET',
		params:data
    });
};